<template>
  <div>
    <BaseTable
      :headers="tableHeaders"
      :items="participationList"
      :pagination="pagination"
      :loading="isLoading"
      :on-row-click="view"
      @update:page="getAll"
    >
      <template #item.viesas="{ item }">
        {{ !!item.viesas ? $t('common.yes') : $t('common.no') }}
      </template>
    </BaseTable>
  </div>
</template>

<script>
import BaseTable from './base/BaseTable';
import tpdParticipationService from '@/services/tpd-participation.service';

export default {
  name: 'TpdParticipationList',

  components: {BaseTable},

  props: {
    licId: {
      type: Number
    },
    profileId: {
      type: Number
    }
  },

  data() {
    return {
      isLoading: false,
      participationList: [],
      pagination: {},
      params: { licId: this.licId, profileId: this.profileId },
    };
  },

  computed: {
    tableHeaders() {
      const translationKey = 'pages.tpd.participation.table.headers';
      return [
        {text: this.$t(`${translationKey}.nr`), value: 'nr'},
        {text: this.$t(`${translationKey}.preparationNr`), value: 'rengimo_nr'},
        {text: this.$t(`${translationKey}.name`), value: 'pavad'},
        {text: this.$t(`${translationKey}.category`), value: 'pl_rusis'},
        {text: this.$t(`${translationKey}.subCategory`), value: 'pl_porusis'},
        {text: this.$t(`${translationKey}.level`), value: 'terit_dydis_l'},
        {text: this.$t(`${translationKey}.state`), value: 'busena'},
        {text: this.$t(`${translationKey}.startDate`), value: 'pradzia'},
        {text: this.$t(`${translationKey}.registrationDate`), value: 'registruota'},
        {text: this.$t(`${translationKey}.validityDate`), value: 'isigaliojo'},
        {text: this.$t(`${translationKey}.removalDate`), value: 'isregistruota'},
        {text: this.$t(`${translationKey}.approvalDate`), value: 'tvirt_data'},
        {text: this.$t(`${translationKey}.version`), value: 'versija'},
      ];
    },
  },

  created() {
    this.getAll();
  },

  methods: {
    getAll(page = 1) {
      this.isLoading = true;
      const params = {...this.params, page };
      tpdParticipationService
        .getList(params)
        .then((res) => {
          this.participationList = res.data.tpd;
          this.pagination = {
            page: res.data.page,
            total: res.data.total,
            pageSize: res.data.pageSize,
          };
        })
        .catch(() => {
          this.participationList = [];
          this.pagination = {};
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    view(item) {
      window.location.href = this.$url(item.tpd_url);
    },
  },
};
</script>
